import { ArrowUpRight } from "lucide-react";

function QuickActionCard({
  icon: Icon,
  title,
  description,
  onClick,
}) {
  return (
    <button
      type="button"
      className="quick-action-card"
      onClick={onClick}
    >
      <span className="quick-action-card__icon">
        <Icon size={21} />
      </span>

      <span className="quick-action-card__content">
        <strong>{title}</strong>
        <span>{description}</span>
      </span>

      <ArrowUpRight
        className="quick-action-card__arrow"
        size={18}
      />
    </button>
  );
}

export default QuickActionCard;